// locales/es.ts — Español (idioma base)
export const es = {

    // ── Navegación ──────────────────────────────────────────────────────────────
  nav: {
    dashboard:  'Dashboard',
    newSession: '+ Sesión',
    import:     '⬆ Import',
    stats:      '◈ Stats',
    sessions:   'Historial',
    calendar:   'Calendario',
    goals:      'Metas',
    staking:    'Staking',
    guide:      'Guía',
    dailyQuiz:  'Quiz Diario',
    blog:       'Blog',
  },

    // ── Header ───────────────────────────────────────────────────────────────────
  header: {
    bankroll:    'BANKROLL',
    pnlTotal:    'P&L TOTAL',
    syncing:     'Sincronizando...',
    plan:        'Plan',
    logout:      'Cerrar sesión',
    resetData:   'Reset',
    upgradePro:  '⬆ Pro',
    settings: 'Configuración'
  },
    // ─── Settings modal ───────────────────────────────────────────────────────
  settings: {
    title: 'Configuración',
    savingChanges: 'Guardando…',
    privacy: {
      title: 'Privacidad y datos',
      description: 'Controlá cómo se usan tus stats para mejorar GrindLog para todos.',
      shareStatsLabel: 'Compartir mis stats anónimas',
      shareStatsHelp: 'Ayudás a GrindLog a construir benchmarks de población. Cuando tengamos suficientes datos, tus rangos saludables se van a calcular a partir de jugadores ganadores reales de tu stake en lugar de estimaciones teóricas de solvers.',
      whatIsSharedSummary: '¿Qué se comparte exactamente?',
      sharedItem1: 'Stats agregadas por torneo (VPIP, PFR, CBet, etc.) — solo conteos y porcentajes, nunca el hand history crudo.',
      sharedItem2: 'Rango de buy-in y formato de torneo, para poder agrupar los benchmarks por stake.',
      sharedItem3: 'Un identificador anónimo — nunca tu email, tu nombre o algo que te identifique.',
      sharedItem4: 'Podés revocar esto en cualquier momento y tus próximas importaciones dejan de compartirse.',
      revokeConfirmMessage: 'Además, ¿querés eliminar tus datos históricos compartidos? Esto no se puede deshacer.',
    },
  },
    // ─── Modal de anuncios ────────────────────────────────────────────────────
  announcements: {
    title: 'Novedades',
    cta:   'Entendido',
  },

      // ─── Opt-in modal (post-primera-importación) ──────────────────────────────
  optInModal: {
    title: 'Ayudá a mejorar los benchmarks',
    intro: 'GrindLog usa rangos teóricos de solvers para marcar tus leaks. Funcionan, pero asumen que los oponentes juegan GTO — algo que rara vez es cierto en stakes bajos. Con tu ayuda podemos hacerlo mejor.',
    bullet1: 'Compartí tus stats anónimas y vamos a calcular rangos saludables a partir de jugadores ganadores REALES de tu stake.',
    bullet2: 'Solo se comparten conteos y porcentajes. Nunca tus hand histories, tus cartas, ni tu identidad.',
    bullet3: 'Vas a ver benchmarks de población una vez que tengamos suficientes datos, segmentados por stake y formato.',
    bullet4: 'Podés cambiar esto en cualquier momento desde Configuración.',
    fineprint: 'Al aceptar, le permitís a GrindLog incluir tus stats en agregados anónimos. Nunca compartimos datos individuales con terceros.',
    acceptBtn: 'Sí, compartir mis stats',
    savingBtn: 'Guardando…',
    acceptedBtn: '✓ ¡Gracias!',
    declineBtn: 'Ahora no',
    changeLater: 'Podés cambiar esto cuando quieras desde Configuración.'
  },

  // ── Auth ─────────────────────────────────────────────────────────────────────
  auth: {
    email:           'Email',
    password:        'Contraseña',
    login:           'Ingresar',
    register:        'Registrarse',
    registerFree:    'Registrate gratis',
    loginTitle:      'Bienvenido de vuelta',
    registerTitle:   'Crear cuenta',
    resetTitle:      'Resetear contraseña',
    loginSub:        'Tus sesiones te esperan.',
    registerSub:     'Gratis. Sin tarjeta. Sin límites.',
    resetSub:        'Te enviamos un link a tu email.',
    googleLogin:     'Continuar con Google',
    magicLink:       'Link mágico',
    sendLink:        'Enviar link',
    checkEmail:      'Revisá tu email — te mandamos un link de acceso',
    confirmEmail:    'Revisá tu email para confirmar tu cuenta.',
    resetSent:       'Te enviamos un link para resetear tu contraseña.',
    wrongCredentials:'Email o contraseña incorrectos',
    weakPassword:    'La contraseña debe tener al menos 6 caracteres',
    tabLogin:        'Ingresar',
    tabRegister:     'Registrarse',
    tabMagic:        'Link mágico',
  },

  // ── Dashboard ────────────────────────────────────────────────────────────────
  dashboard: {
    bankroll:       'BANKROLL',
    netProfit:      'PROFIT NETO',
    winRate:        'WIN RATE',
    totalRoi:       'ROI TOTAL',
    sessions:       'SESIONES',
    bestSession:    'MEJOR SESIÓN',
    worstSession:   'PEOR SESIÓN',
    totalInvested:  'TOTAL INVERTIDO',
    roiByFormat:    'ROI POR FORMATO',
    recentSessions: 'ÚLTIMAS SESIONES',
    viewAll:        'Ver todo →',
    noSessions:     'Todavía no hay sesiones',
    firstSession:   'Cargá tu primera sesión para empezar a trackear',
  },

  // ── Session Form ─────────────────────────────────────────────────────────────
  session: {
    title:          'NUEVA SESIÓN',
    typeCash:       'CASH GAME',
    typeTournament: 'TORNEO',
    typeMulti:      'MULTI-TORNEO',
    date:           'Fecha',
    platform:       'Plataforma',
    duration:       'Duración (min)',
    notes:          'Notas',
    notesPlaceholder:'Notas generales...',
    stakes:         'Stakes (ej: NL10, 0.05/0.10)',
    stakesPlaceholder:'NL10',
    buyIn:          'Buy-In ($)',
    cashOut:        'Cash Out ($)',
    grossProfit:    'Profit bruto',
    staked:         'Sesión stakeada',
    stakerName:     'Nombre del backer',
    myPct:          'Mi % del profit',
    save:           'Guardar Sesión',
    saved:          '✓ Guardado',
    // Tournament fields
    tournamentName: 'Nombre del torneo (opcional)',
    tournamentBuyIn:'Buy-In $',
    rebuys:         'Rebuys',
    addOn:          'Add-On $',
    prize:          'Prize $',
    bounties:       'Bounties $',
    position:       'Posición',
    entrants:       'Entrants',
    addTournament:  '+ Torneo',
    format:         'Formato',
    levelStakes:    'Casino, torneo, nivel...',
    goal:           'META',
  },

    // ── Sessions Table ────────────────────────────────────────────────────────────
  sessionsTable: {
    title:        'HISTORIAL',
    date:         'Fecha',
    type:         'Tipo',
    platform:     'Plataforma',
    buyIn:        'Buy-In',
    cashOut:      'Cash Out',
    profit:       'Profit',
    duration:     'Duración',
    notes:        'Notas',
    cash:         'Cash',
    tournament:   'Torneo',
    multi:        'Multi',
    export:       'Exportar CSV',
    noResults:    'Sin sesiones con esos filtros.',
    deleteConfirm:'¿Eliminar?',
    staking:      'Staking',
  },

    // ── Goals ────────────────────────────────────────────────────────────────────
  goals: {
    title:          'METAS',
    completed:      'COMPLETADAS',
    createGoal:     'Crear Meta',
    cancel:         'Cancelar',
    type:           'Tipo',
    typeBankroll:   'Bankroll objetivo',
    typeSessions:   'Sesiones a jugar',
    typeRoi:        'ROI objetivo %',
    description:    'Descripción (opcional)',
    deadline:       'Deadline (opcional)',
    targetBankroll: 'Target $',
    targetSessions: 'N° sesiones',
    targetRoi:      'ROI %',
    empty:          'No hay metas activas. ¡Creá una para mantenerte enfocado!',
    labelBankroll:  'Llegar a ${{val}} de bankroll',  // eslint-disable-line no-template-curly-in-string
    labelSessions:  'Jugar {{val}} sesiones',
    labelRoi:       'Mantener ROI de {{val}}%',
  },

    // ── Staking ───────────────────────────────────────────────────────────────────
  staking: {
    title:          'STAKING',
    byBacker:       'POR BACKER',
    sessions:       'Sesiones',
    stakedSessions: 'Sesiones stakeadas',
    grossProfit:    'Profit bruto total',
    backerShare:    'Parte de backers',
    myProfit:       'Mi profit neto',
    gross:          'Bruto',
    myPart:         'Mi parte',
    theirPart:      'Su parte',
    noStaked:       'No tenés sesiones stakeadas registradas.',
    unnamed:        'Sin nombre',
  },

    // ── Import ────────────────────────────────────────────────────────────────────
  import: {
    title:          'IMPORT POKERCRAFT',
    subtitle:       'Arrastrá los archivos .txt exportados desde GGPoker → PokerCraft → History',
    dropzone:       'Arrastrá los .txt de PokerCraft acá',
    dropzoneHint:   'Podés soltar toda la carpeta de una semana a la vez',
    processing:     'Procesando archivos...',
    viewStats:      '◈ Ver Stats & IA ({{n}} torneos) →',
    // Table headers
    date:           'Fecha',
    tournament:     'Torneo',
    format:         'Formato',
    buyIn:          'Buy-In',
    hands:          'Manos',
    busts:          'Busts',
    detected:       'Detectados',
    buyInTotal:     'Buy-In total',
    pos:            'Pos.',
    prize:          'Prize $',
    bounties:       'Bounties $',
    bust:           'Bust',
    busted:         'Busted',
    survived:       'Sobrevivió',
    selectAll:      'Sel. todos',
    importBtn:         'Importar {{n}} torneos →',
    importAndViewBtn:  'Guardar y ver stats ({{n}}) →',
    importSaving:      'Guardando...',
    importDone:     '✓ {{n}} torneos importados exitosamente',
    // How-to
    howToTitle:     'CÓMO EXPORTAR DE GGPOKER',
    howToStep1:     'Abrí GGPoker → PokerCraft',
    howToStep2:     'Andá a History → elegí el rango de fechas',
    howToStep3:     'Hacé click en Export → descargás una carpeta con .txt',
    howToStep4:     'Arrastrá todos los .txt acá arriba',
  },

  // ── Stats ─────────────────────────────────────────────────────────────────────
  stats: {
    title:        'ESTADÍSTICAS DE JUEGO',
    subtitle:     '{{hands}} manos · {{tournaments}} torneos',
    empty:        'Importá torneos desde PokerCraft para ver tus estadísticas.',
    tabPreflop:   'Preflop',
    tabFlop:      'Flop',
    tabTurn:      'Turn',
    tabRiver:     'River',
    tabShowdown:  'Showdown',
    // Sections
    flop:         'FLOP',
    turn:         'TURN',
    river:        'RIVER',
    vsCbetFlop:   'VS CBET FLOP',
    vsCbetTurn:   'VS DOUBLE BARREL',
    vsCbetRiver:  'VS CBET RIVER',
    donkBets:     'DONK BETS',
    probeBets:    'PROBE BETS',
    checkRaise:   'CHECK-RAISE',
    positions:    'POSICIONES',
    fold:         'Fold',
    call:         'Call',
    // AI panel
    aiTitle:      '◈ ANÁLISIS IA',
    aiSub:        'Claude analiza tus leaks y genera un diagnóstico priorizado por EV',
    aiGenerate:   'Generar análisis →',
    aiLoading:    'Analizando...',
    aiAnalyzing:  'Analizando {{n}} manos...',
    aiRegenerate: '↺ Regenerar',
    aiNeedHands:  'Necesitás {{n}}+ manos (tenés {{have}})',
    aiConsent:    'Compartir mis stats anónimas para calcular benchmarks de la población por stake',
    aiError:      'Error al conectar. Intentá de nuevo.',
    aiDevError:   'No se puede conectar al servidor. En desarrollo: ejecutá node dev-server.js',
    paywallText:  '🔒 El Coach IA es una función Pro. Detectá tus fugas y mejorá tu win rate.',
    paywallBtn:   'Activar Pro — desde $4/mes',
    // ─── Breakdown gate ──────────────────────────────────────────────────
    upgradePrompt: {
      text: 'Activá Pro para desbloquear el desglose de {{feature}}.',
      btn:  'Activar Pro — desde $4/mes',
    },
    // Stat labels
    opt:          'opt',
    // ─── Generic ─────────────────────────────────────────────────────────
    insufficientSample: 'muestra insuficiente',

    // ─── Fase 2: Fold to 3Bet split ──────────────────────────────────────
    foldTo3betVsAllin: 'vs All-in / Shove',
    foldTo3betVsNonAllin: 'vs 3Bet sin all-in',

    // ─── Fase 4: Matchup link inside Fold to 3Bet ────────────────────────
    foldTo3betShowMatchup: '+ Ver desglose por matchup →',
    foldTo3betHideMatchup: '− Ocultar desglose por matchup',

    // ─── Fase 3: Open Raise (RFI) ────────────────────────────────────────
    openRaise: 'Open Raise (RFI)',
    squeeze:   'Squeeze',
    fourbet:   '4Bet',
    openLimp:  'Open Limp',

    // ─── Fase 1: CBet Flop matchup breakdown ─────────────────────────────
    matchup: {
      empty: 'Aún no hay datos por matchup. Jugá más manos para ver el desglose por posición.',
      warning: 'Ningún matchup tiene suficiente muestra todavía (mínimo {{n}} oportunidades). El número general de arriba es un promedio entre situaciones que probablemente se juegan de forma muy distinta. Seguí jugando para desbloquear el desglose por matchup.',
      cbetFlopTitle: 'CBet Flop por posición hero × villano',
      threebetTitle: '3Bet por posición hero × opener',
      foldTo3betTitle: 'Fold to 3Bet por posición hero × 3bettor',
      multi: 'Multiway (3+ jugadores)',
      thMatchup: 'Matchup',
      thCbet: 'CBet %',
      thThreebet: '3Bet %',
      thFold: 'Fold %',
      thBenchmark: 'Saludable',
      thSample: 'Muestra',
      thSuccess: 'Éxito %',
      moreInsufficient: "{{n}} matchup(s) más con muestra insuficiente",
      benchmarkDisclaimer: 'Los rangos saludables son aproximaciones basadas en consenso de solvers y coaching. Varían según SPR, textura del board y meta del stake. Usalos como dirección, no como verdad absoluta.'
    },

    // ─── VPIP por posición breakdown ─────────────────────────────────────
    vpip: {
      rowLabel: 'VPIP por posición',
      empty: 'Todavía no hay manos con posición conocida. Importá más historiales para ver tu VPIP por posición.',
      warning: 'Ninguna posición tiene suficiente muestra todavía (mínimo {{n}} manos por posición). El VPIP global de arriba es un promedio entre posiciones que se juegan de forma muy distinta. Seguí jugando para desbloquear el desglose.',
      title: 'VPIP % por posición',
      thPosition: 'Posición',
      thVpip: 'VPIP %',
      thBenchmark: 'Saludable',
      thSample: 'Muestra',
      lowTag: '(bajo)'
    },
    // ─── Fase 3: RFI by position breakdown ───────────────────────────────
    rfi: {
      empty: 'Todavía no hay oportunidades de open raise. Jugá más manos para ver tu desglose de RFI por posición.',
      warning: 'Ninguna posición tiene suficiente muestra todavía (mínimo {{n}} oportunidades por posición). El número general de arriba es un promedio entre posiciones que deberían jugarse de forma muy distinta. Seguí jugando para desbloquear el desglose por posición.',
      title: 'Open Raise % por posición (RFI)',
      thPosition: 'Posición',
      thRfi: 'RFI %',
      thLimp: 'Limp %',
      thBenchmark: 'Saludable',
      thSample: 'Muestra',
      lowTag: '(bajo)'
    },
    foldToPush: {
      rowLabel: 'Fold to Push',
      title: 'Fold to Push por stack del shover',
      empty: 'Todavía no hay spots de fold-to-push. Importá más manos para ver cómo respondés a los all-ins preflop.',
      warning: 'Ningún bin de stack tiene suficiente muestra todavía (mínimo {{n}} spots). Seguí jugando para desbloquear la evaluación.',
      thStack: 'Stack del shover',
      thFold: 'Fold %',
      thBenchmark: 'Nash (fold %)',
      thSample: 'Muestra',
      lowTag: '(bajo)',
    },
    pushFold: {
      label: 'Push/Fold (≤15bb)',
      title: 'Push/Fold por posición — solo short stack',
      empty: 'Todavía no hay oportunidades de push/fold. Jugá más manos en short stack para ver tu frecuencia de push por posición.',
      warning: 'Ninguna posición tiene suficiente muestra todavía (mínimo {{n}} oportunidades). Seguí jugando en short stack para desbloquear la evaluación.',
      thPosition: 'Posición',
      thPush: 'Push %',
      thNash: 'Rango Nash',
      thLimp: 'Limp %',
      thMinRaise: 'Min-raise %',
      thSample: 'Muestra',
      lowTag: '(bajo)',
      leakTooltip: 'Leak detectado: estás limpeando o haciendo min-raise en territorio push/fold',
      disclaimer: 'Los rangos Nash son aproximaciones chipEV ponderadas a ~10bb. Ajustá hacia tighter en spots ICM-sensibles (burbuja, mesa final). Los targets de limp y min-raise son 0% — cualquier valor distinto de cero es un leak fundamental de la teoría push/fold.',
      switchStackHint: "El análisis de Push/Fold solo está disponible con el filtro 'Short stack'. Cambiá el selector de stack arriba para ver tu desglose."
    },
    cbetTexture: {
      label: 'CBet Flop (por textura)',
      title: 'CBet Flop por textura × posición — solo heads-up',
      empty: 'Todavía no hay oportunidades de cbet HU. Jugá más manos como preflop aggressor en pots HU para ver tu frecuencia de cbet por textura.',
      warning: 'Ningún bucket de textura tiene suficiente muestra todavía (mínimo {{n}} oportunidades). Seguí jugando para desbloquear la evaluación.',
      thTexture: 'Textura',
      thPosition: 'Pos',
      thCbet: 'CBet %',
      thBenchmark: 'Saludable',
      thSample: 'Muestra',
      lowTag: '(baja)',
      texDry: 'Dry',
      texSemiWet: 'Semi-wet',
      texWet: 'Wet',
      texPaired: 'Paired',
      texMonotone: 'Monotone',
      disclaimer: 'Los benchmarks son aproximaciones chipEV de solvers para pots SRP HU. La frecuencia óptima real varía con el SPR, el board exacto, y el tipo de villain. El cbet multiway se trackea por separado — este desglose solo cubre flops heads-up.'
    },
    cbetTextureMulti: {
      label: 'CBet Flop (multiway)',
      title: 'CBet Flop por textura — 3+ jugadores al flop',
      empty: 'Todavía no hay oportunidades de cbet multiway. Jugá más manos como preflop aggressor en pots con 3+ jugadores para ver tu frecuencia de cbet multiway por textura.',
      warning: 'Ningún bucket de textura tiene suficiente muestra todavía (mínimo {{n}} oportunidades). Seguí jugando para desbloquear la evaluación.',
      disclaimer: 'Los benchmarks de cbet multiway son sustancialmente más bajos que HU porque el range advantage se diluye con cada jugador extra. En multiway, cbeteá solo cuando tu MANO puede soportar el bet (top pair+, draws fuertes) — no por equity del rango. Sizings de 33%–50% suelen ser preferibles a 66%.'
    },
    cbet3BetPot: {
      rowLabel:    'CBet Flop (pozo 3beteado)',
      title:       'CBet Flop en pozos 3beteados — IP vs OOP',
      empty:       'Todavía no hay spots de cbet en pozo 3beteado como 3bettor. Jugá más manos para ver este desglose.',
      thPos:       'Pos',
      thCbet:      'CBet %',
      thBenchmark: 'Saludable',
      thSample:    'Muestra',
      lowTag:      '(baja)',
      disclaimer:  'Benchmarks GTO para pozos 3beteados HU (SPR ~7-9). IP: rangos polares favorecen bet alto y frecuente. OOP: más checks para proteger el rango; cbets con nutted hands y bluffs selectivos.',
    },
    dateFilter: {
      last7:       'Últimos 7 días',
      last30:      'Últimos 30 días',
      thisMonth:   'Este mes',
      lastMonth:   'Mes anterior',
      allTime:     'Todo el tiempo',
      from:        'Desde',
      to:          'Hasta',
      noData:      'Sin torneos en este período. Probá un rango más amplio.',
    },
  },

  // ── Calendar ──────────────────────────────────────────────────────────────────
  calendar: {
    sessions:       'Sesiones',
    profit:         'Profit',
    winDays:        'Días ganadores',
    lossDays:       'Días perdedores',
    next:           'Siguiente ›',
    prev:           '‹ Anterior',
    tournaments:    '{{n}} torneos',
  },

  // ── Upgrade Modal ─────────────────────────────────────────────────────────────
  upgrade: {
    title:          'GrindLog Pro',
    subtitle:       'Coaching con IA + benchmarks de la población',
    featureAi:      'Coach IA — diagnóstico de leaks con inteligencia artificial',
    featureBench:   'Benchmarks por stake — comparate vs la población',
    featureSync:    'Sync en la nube — tus datos en cualquier dispositivo',
    featureExport:  'Exportación avanzada — CSV con todas las métricas',
    featureFuture:  'Todo lo que viene — el precio Pro se fija hoy',
    monthly:        'Plan mensual',
    yearly:         'Plan anual · USD 5/mes',
    yearlyBadge:    '28% OFF',
    launchBanner:   '🚀 Precio lanzamiento · Solo para los primeros usuarios',
    monthlyAmount:  'USD 4',
    monthlyPeriod:  '/mes',
    monthlyRegular: 'después USD 7/mes',
    monthlyLabel:   '3 meses · luego precio regular',
    yearlyAmount:   'USD 60',
    yearlyPeriod:   '/año',
    yearlyRegular:  'USD 5/mes · el mejor precio',
    yearlyLabel:    'Pago anual · sin renovación sorpresa',
    cancel:         'Cancelá cuando quieras. Whop procesa el pago — no guardamos datos de tarjeta.',
    support:        '¿Problemas?',
    errorCheckout:  'Error al iniciar checkout',
    comingSoonTitle: 'Próximamente',
    comingSoonMessage: 'La versión Pro estará disponible el 1 de abril.',
    comingSoonSub: 'Estamos preparando las mejores herramientas de análisis para tu grind.',
    backSoon: 'Volver a la app',
  },

  // ── Common ────────────────────────────────────────────────────────────────────
  common: {
    loading:  'Cargando',
    saving:   'Guardando...',
    delete:   'Eliminar',
    cancel:   'Cancelar',
    confirm:  '¿Confirmar?',
    yes:      'Sí',
    no:       'No',
    close:    'Cerrar',
    currency: 'USD',
    free:     'GRATIS',
    pro:      'PRO',
  },

  // ── Guide ────────────────────────────────────────────────────────────────────
    guide: {
    title:          '📖 Cómo usar GrindLog',
    subtitle:       'Importá tus torneos de GGPoker en menos de 2 minutos y empezá a ver tus stats reales.',
    tabGuide:       '📋 Guía paso a paso',
    tabStats:       '📊 Entendé tus stats',
    tabFaq:         '❓ FAQ',
    zoomHint:       'Clic para ampliar',

    introText:      'GrindLog importa directamente los archivos que exporta PokerCraft (la herramienta de análisis integrada en GGPoker). No necesitás copiar nada a mano — el proceso es automático.',

    step1Title:     'Abrí PokerCraft desde el lobby de GGPoker',
    step1Body:      'En el cliente de GGPoker, mirá la barra inferior de la pantalla. Entre el cartel de Responsible Gaming y el selector de idioma vas a encontrar el ícono de PokerCraft. Hacé clic ahí para abrirlo.',
    step1Tip:       'PokerCraft es gratuito y viene incluido con tu cuenta de GGPoker.',
    step1ImgAlt:    'Lobby de GGPoker con botón PokerCraft',

    step2Title:     'Andá a la pestaña Torneos y elegí el rango de fechas',
    step2Body:      'Dentro de PokerCraft, hacé clic en la pestaña Torneos. Usá los filtros de fecha para seleccionar el período que querés analizar. Una vez que aparezcan los torneos, vas a ver dos botones verdes arriba a la derecha:',
    step2Li1:       'Download Game Summaries — contiene buy-in exacto, premio, posición final y cantidad de jugadores',
    step2Li2:       'Download Game Histories — contiene todas tus manos jugadas (para calcular VPIP, PFR, CBet, etc.)',
    step2Tip:       'Podés filtrar por nombre de torneo o buy-in para exportar solo lo que te interesa.',
    step2ImgAlt:    'Pestaña Torneos en PokerCraft',

    step3Title:     'Descargá los dos archivos',
    step3Body:      'Hacé clic en ambos botones de descarga. Cada uno genera un archivo ZIP separado. Te van a aparecer en tu carpeta de Descargas.',
    step3Warning:   'Si solo descargás un tipo, vas a tener información incompleta: sin el Summary no hay buy-in ni posición final exactos; sin el History no hay estadísticas de manos.',
    step3ImgAlt:    'Botones de descarga en PokerCraft',

    step4Title:     'Descomprimí los ZIP y juntá todos los .txt',
    step4Body:      'En tu carpeta de Descargas vas a ver dos carpetas comprimidas. Descomprimí ambas (clic derecho → Extraer). Dentro vas a encontrar archivos .txt — algunos son de tipo Game History y otros de Game Summary. Podés juntarlos todos en una sola carpeta.',
    step4Tip:       'Si descargaste varios rangos de fechas, podés mezclar todos los .txt en una misma carpeta — GrindLog los matchea automáticamente por ID de torneo.',
    step4ImgAlt:    'Archivos descargados en el explorador',

    step5Title:     'Seleccioná todos los .txt y arrastralos a GrindLog',
    step5Body1:     'En GrindLog, andá a la pestaña Import. Seleccioná todos los archivos .txt (Ctrl+A o Cmd+A) y arrastralos sobre la zona de drop, o hacé clic en la zona para buscarlos desde el explorador.',
    step5Body2:     'GrindLog detecta automáticamente el tipo de cada archivo y matchea los pares History + Summary por ID de torneo. En segundos vas a ver la tabla con todos tus torneos.',
    step5Tip:       'Podés importar cientos de archivos a la vez. GrindLog los procesa todos juntos.',
    step5ImgAlt:    'Drop zone de importación en GrindLog',

    step6Title:     'Revisá la tabla y hacé clic en Importar',
    step6Body:      'La tabla muestra cada torneo con su estado de match:',
    step6Li1:       '✓ Verde — Tiene History + Summary, datos completos',
    step6Li2:       'H Amarillo — Solo History, sin resultado final',
    step6Li3:       'S Gris — Solo Summary, sin estadísticas de manos',
    step6Body2:     'Podés editar el buy-in o el premio de cualquier torneo antes de importar. Cuando estés listo, hacé clic en Importar torneos.',
    step6ImgAlt:    'Tabla de torneos listos para importar',

    step7Title:     '¡Listo! Explorá tus stats y el análisis IA',
    step7Body:      'Una vez importados, andá a Stats para ver tu VPIP, PFR, CBet, y todos tus indicadores con rangos óptimos de referencia. Los usuarios Pro también pueden generar un análisis con IA que identifica tus leaks más costosos y te da un plan concreto para las próximas sesiones.',
    step7Tip:       'El análisis IA está disponible en el plan Pro y requiere al menos 100 manos para generar un diagnóstico confiable.',
    step7ImgAlt:    'Vista de estadísticas en GrindLog',

    statsIntro:     'Una guía rápida de qué significa cada estadística y cuál es el rango óptimo para un jugador MTT regular.',
    statsCatPreflop:'🃏 Preflop',
    statsCatCbet:   '🔥 C-Bet (Continuation Bet)',
    statsCatDef:    '🛡️ Defensa',
    statsCatSD:     '🏆 Showdown',
    statsColStat:   'Stat',
    statsColRange:  'Rango óptimo',
    statsColDesc:   'Qué mide',
    statsTip:       'Los rangos óptimos son para MTT regulares (micros a medios stakes). En turbo o hyper turbo algunos valores cambian. El análisis IA de GrindLog ajusta el diagnóstico según tu muestra específica.',

    vpipDesc:       '% de manos que entrás voluntariamente al pozo. Muy alto = jugás basura. Muy bajo = muy tight.',
    pfrDesc:        '% de manos donde subís preflop. Debe ser cercano al VPIP para no ser pasivo.',
    pfrVpipDesc:    'Ratio de agresión preflop. Menos del 70% indica que llamás demasiado en vez de subir.',
    threebetDesc:   '% de veces que re-subís cuando alguien abrió. Muy bajo = predecible y explotable.',
    fold3bDesc:     '% de veces que foldás cuando te hacen 3bet. Más del 65% = te roban fácil.',
    atsDesc:        'Attempt to Steal: % de veces que subís desde BTN/CO/SB cuando todos foldearon. Clave para acumular fichas.',
    cbetFDesc:      '% de veces que apostás en el flop cuando fuiste el agresor preflop.',
    cbetTDesc:      'Double barrel: seguís apostando el turn después de haber apostado el flop. Debe ser más selectivo que el flop.',
    cbetRDesc:      'Triple barrel: apostás el river después de haber apostado flop y turn. Muy bajo = dejás dinero en la mesa.',
    cbetFSucDesc:   '% de tus cbets de flop que ganan sin ir a más calles. Referencia de efectividad.',
    foldCbetFDesc:  '% de veces que foldás a una cbet. Más del 50% = te explotan con cualquier two cards.',
    foldCbetTDesc:  '% de veces que foldás en el turn ante una apuesta. Clave contra jugadores agresivos.',
    probeDesc:      '% de veces que apostás en el turn cuando el rival chequeó (sos el caller preflop). Indica agresión en posición.',
    xraiseFlopDesc: 'Check-Raise Flop: % de veces que raiseás después de chequear y que el rival apueste. Segmentado por PFA (vos raiseaste preflop) vs no-PFA.',
    wtsdDesc:       '% de manos (donde viste el flop) que llegás a showdown. Muy alto = llamás demasiado; muy bajo = foldás buenas manos.',
    wsdDesc:        'Win at Showdown: % de showdowns que ganás. Menos del 50% es una alarma seria.',
    wwsfDesc:       'Won When Saw Flop: % de veces que ganás el pozo habiendo visto el flop. Mide agresión postflop general.',
    afDesc:         'Aggression Factor: ratio de apuestas+raises vs calls. Menos de 2 = muy pasivo postflop.',

    faq1q:  '¿Qué diferencia hay entre Game History y Game Summary?',
    faq1a:  'Game History tiene todas las manos que jugaste carta a carta — sirve para calcular VPIP, PFR, CBet y el resto de las estadísticas de juego. Game Summary tiene el resultado del torneo: buy-in exacto, posición final, cuántos jugadores había y cuánto ganaste. Para tener todo completo necesitás los dos. Podés subir solo uno si querés resultados parciales.',
    faq2q:  "Subí los archivos pero algunos torneos aparecen como 'H' o 'S' en vez de '✓'",
    faq2a:  'Eso significa que el torneo tiene solo un tipo de archivo (solo History o solo Summary). Para tener el match completo (✓) necesitás haber descargado ambos ZIPs de PokerCraft y descomprimido todos los archivos juntos antes de subirlos. Si ya los tenés, volvé a la vista de Import, hacé clic en Limpiar y arrastrá todos los .txt de ambas carpetas juntos.',
    faq3q:  '¿Por qué el buy-in que aparece no coincide con lo que pagué?',
    faq3a:  'El buy-in en el Summary es el precio base del torneo (lo que cobró GGPoker). Si entraste por un satélite, ese buy-in no refleja tu costo real — en ese caso, podés editarlo manualmente en la tabla de importación antes de confirmar. GrindLog te deja modificar cualquier campo antes de guardar.',
    faq4q:  '¿Puedo importar torneos de otras plataformas además de GGPoker?',
    faq4a:  'Por ahora GrindLog importa automáticamente el formato de PokerCraft (GGPoker). Para otras plataformas podés cargar torneos manualmente desde + Session, ingresando los datos a mano. Próximamente se agregarán más parsers.',
    faq5q:  '¿Cuántas manos necesito para que el análisis IA sea confiable?',
    faq5a:  'GrindLog requiere mínimo 100 manos para habilitar el análisis IA — con menos, las estadísticas tienen demasiada varianza para diagnosticar leaks reales. Para un diagnóstico sólido, se recomienda al menos 500–1000 manos. Si jugás una sesión liviana, importá varios torneos juntos.',
    faq6q:  'El análisis IA salió en inglés pero tengo la app en español',
    faq6a:  'Esto es un bug conocido que ya fue corregido. Si te sigue pasando, intentá cambiar el idioma a inglés y volver a español antes de generar el análisis. El fix permanente viene en la próxima actualización.',
    faq7q:  '¿Los datos se guardan en la nube o solo en mi dispositivo?',
    faq7a:  'GrindLog guarda tus sesiones localmente en tu navegador y también en la nube con tu cuenta. Podés acceder desde cualquier dispositivo siempre que estés logueado con la misma cuenta.',
    faq8q:  '¿Qué pasa si cierro el navegador sin importar?',
    faq8a:  'Los archivos que arrastraste no se guardan hasta que hacés clic en Importar torneos. Si cerrás la pestaña antes de confirmar, tenés que volver a subir los archivos. Pero una vez importados, los datos están guardados permanentemente en tu cuenta.',
    faq9q:  '¿Puedo borrar torneos importados si me equivoqué?',
    faq9a:  'Sí. Desde la pestaña History podés ver todas tus sesiones importadas y eliminar las que quieras. Los cambios se reflejan inmediatamente en el Dashboard y en Stats.',
    faq10q: '¿Qué significa el badge Pro y qué incluye?',
    faq10a: 'El plan Pro desbloquea: Análisis IA de tus leaks, Stats avanzadas (Triple Barrel, Probe, WWSF, W@SD), Goals y seguimiento de objetivos, Vista de calendario con P&L diario, y el módulo de Staking.',
  },
  footer: {
    // UI labels
    tagline: 'Análisis de torneos de poker.\nParsea tus manos. Mejorá tu juego.',
    colProduct: 'Producto',
    colLegal: 'Legal',
    colSupport: 'Soporte',
    linkDashboard: 'Dashboard',
    linkPricing: 'Precios',
    linkGuide: 'Guía',
    lastUpdated: 'Última actualización',
    lastUpdatedDate: 'Marzo 2026',
    close: 'Cerrar',
    disclaimer: 'GrindLog es una herramienta de análisis de datos. No organiza, facilita ni participa en juegos de azar por dinero real.',

    // Titles (para modal)
    termsTitle: 'Términos de Servicio',
    privacyTitle: 'Política de Privacidad',
    refundTitle: 'Política de Reembolso ↗',

    // ── Terms of Service ──────────────────────────────────────────────────────
    termsContent: `**1. Aceptación de los Términos**

Al acceder o usar GrindLog ("Servicio"), aceptás quedar vinculado por estos Términos de Servicio. Si no estás de acuerdo, no uses el Servicio.

**2. Descripción del Servicio**

GrindLog es una plataforma SaaS de análisis de datos para jugadores de torneos de poker. Permite cargar archivos de historial de manos exportados desde plataformas de terceros y visualizar estadísticas de rendimiento personal (VPIP, PFR, CBet, etc.). En ningún caso se realizan apuestas, partidas ni transacciones de dinero real dentro de la plataforma.

**3. Cuenta de Usuario**

Sos responsable de mantener la confidencialidad de tus credenciales. Ante cualquier uso no autorizado, notificá a support@grindlog.app inmediatamente.

**4. Uso Aceptable**

No podés usar el Servicio para cargar contenido que viole derechos de propiedad intelectual de terceros, ni intentar hacer ingeniería inversa o scraping de la plataforma.

**5. Suscripciones y Facturación**

Las suscripciones se facturan por adelantado (mensual o anual). Podés cancelar en cualquier momento desde la configuración de tu cuenta. La cancelación tiene efecto al finalizar el período de facturación vigente.

**6. Política de Reembolso**

Ver la Política de Reembolso separada disponible en este footer.

**7. Propiedad Intelectual**

Todo el contenido, diseño y código de GrindLog es propiedad exclusiva de Franco Scioli / GrindLog. Tus datos de historial de manos son siempre tuyos.

**8. Sin Garantías**

El Servicio se provee "tal cual". No garantizamos disponibilidad ininterrumpida ni que los resultados estadísticos estén libres de errores.

**9. Limitación de Responsabilidad**

En la máxima medida permitida por la ley, GrindLog no será responsable por daños indirectos, incidentales o consecuentes derivados del uso del Servicio.

**10. Ley Aplicable**

Estos Términos se rigen por las leyes de la República Argentina. Las disputas se someterán a los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires.

**11. Contacto**

support@grindlog.app`,

    // ── Privacy Policy ────────────────────────────────────────────────────────
    privacyContent: `**1. Datos que recopilamos**

**Datos de cuenta:** dirección de email y contraseña (hasheada). **Historial de manos:** archivos que cargás voluntariamente, procesados para generar estadísticas y descartados inmediatamente; no almacenamos archivos crudos más tiempo del estrictamente necesario. **Datos de uso:** páginas visitadas, interacciones con funciones y registros de errores, para mejorar el producto. **Datos de pago:** procesados íntegramente por Whop. Nunca almacenamos números de tarjeta.

**2. Cómo usamos tu información**

Para proveer, mantener y mejorar el Servicio; para enviarte emails transaccionales (confirmación de cuenta, recibos de suscripción); para responder consultas de soporte.

**3. Compartir datos**

No vendemos ni compartimos tus datos personales con terceros, excepto: **Proveedores de servicio:** Supabase (base de datos), Vercel (hosting), Whop (pagos), Resend (email transaccional), cada uno regido por sus propias políticas de privacidad. **Requerimientos legales:** si lo exige la ley o una orden judicial.

**4. Retención**

Los datos de cuenta se conservan mientras tu cuenta esté activa. Podés solicitar la eliminación en cualquier momento enviando un email a support@grindlog.app.

**5. Cookies**

Usamos únicamente cookies de sesión esenciales para la autenticación. No usamos cookies de publicidad ni tracking de terceros.

**6. Seguridad**

Todos los datos están encriptados en tránsito (TLS) y en reposo. El acceso a las bases de datos de producción está restringido.

**7. Tus derechos**

Tenés derecho a acceder, corregir o eliminar tus datos personales. Contacto: support@grindlog.app

**8. Menores**

El Servicio no está dirigido a menores de 16 años. No recopilamos datos de menores deliberadamente.

**9. Cambios**

Notificaremos a los usuarios por email ante cambios materiales en esta política.

**10. Contacto**

support@grindlog.app`,

    // ── Refund Policy ─────────────────────────────────────────────────────────
    refundContent: `**Nuestro compromiso**

Queremos que estés completamente satisfecho con GrindLog. Si no es así, lo resolvemos.

**Garantía de 14 días**

Si por cualquier motivo no estás satisfecho con tu compra, podés solicitar un **reembolso completo dentro de los 14 días** de tu pago inicial. Sin preguntas.

**Cómo solicitar un reembolso**

Enviá un email a support@grindlog.app con el asunto "Reembolso" e incluí: el email de tu cuenta y tu número de orden (disponible en tu recibo). Procesamos el reembolso en 5–7 días hábiles. Los reembolsos se acreditan en el método de pago original.

**Después de los 14 días**

Las solicitudes fuera del plazo se evalúan caso a caso. Circunstancias excepcionales (corte prolongado del servicio, errores de facturación) siempre serán atendidas.

**Renovaciones**

Si fuiste cobrado por una renovación y querés cancelar, contactanos dentro de las 48 horas del cobro para un reembolso completo de esa renovación.

**Cancelaciones**

Cancelar tu suscripción detiene cargos futuros pero no genera automáticamente un reembolso del período vigente. Contactanos si considerás que corresponde un reembolso.

**Contacto**

support@grindlog.app`,
  },

  // ── Blog ─────────────────────────────────────────────────────────────────────
  blog: {
    title:          'Blog',
    subtitle:       'Estrategia, producto y poker en profundidad',
    empty:          'No hay posts publicados todavía.',
    readMore:       'Leer más',
    back:           '← Volver al blog',
    draft:          'Borrador',
    newPost:        '+ Nuevo post',
    editPost:       'Editar',
    deletePost:     'Eliminar',
    deleteConfirm:  '¿Eliminar este post? Esta acción no se puede deshacer.',
    formTitleCreate:'Nuevo post',
    formTitleEdit:  'Editar post',
    formTitleEs:    'Título (ES)',
    formTitleEn:    'Título (EN)',
    formExcerptEs:  'Resumen (ES)',
    formExcerptEn:  'Resumen (EN)',
    formContentEs:  'Contenido (ES) — Markdown',
    formContentEn:  'Contenido (EN) — Markdown',
    formOgImage:    'URL imagen OG (og:image / twitter:image)',
    formPublished:  'Publicar',
    formSave:       'Guardar',
    formCancel:     'Cancelar',
    saving:         'Guardando...',
    minRead:        'min de lectura',
  },

  // ── Teams ────────────────────────────────────────────────────────────────────
  teams: {
    // Nav
    navLabel: 'Teams',

    // Estados generales
    loading:   'Cargando team...',
    noTeam:    'No estás en ningún team todavía.',
    noTeamSub: 'Si recibiste una invitación, hacé click en el link del email para unirte.',

    // Crear team
    createTitle:       'Crear un team',
    createName:        'Nombre del team',
    createNamePlaceholder: 'Ej: Stable Fenix',
    createSlug:        'URL del team (slug)',
    createSlugHelp:    'Solo letras, números y guiones. No se puede cambiar después.',
    createSeats:       'Cantidad de asientos',
    createSeatsHelp:   'Cantidad de jugadores que podés agregar al team.',
    createBtn:         'Crear team',
    creating:          'Creando...',
    createError:       'Error al crear el team. Intentá de nuevo.',
    createProRequired: 'Para crear un team necesitás el plan GrindLog Teams. Desde $25/mes para un equipo de 5.',
    createUpgradeBtn:  '⬆ Ver planes Teams',

    // Vista del jugador (Mi Team)
    myTeamTitle:       'Mi Team',
    coachLabel:        'Coach',
    memberSince:       'Miembro desde',
    statusActive:      'Activo',
    statusInvited:     'Invitado (pendiente)',
    statusLeft:        'Saliste del team',

    // Toggle sync
    syncTitle:         'Team Sync',
    syncDescription:   'Cuando está activo, tus stats agregados (VPIP, CBet, 3Bet, etc.) se envían al coach después de cada análisis. Nunca se comparten hand histories crudas.',
    syncOn:            'Sync activo',
    syncOff:           'Sync desactivado',
    syncToggleOn:      'Activar sync',
    syncToggleOff:     'Desactivar sync',
    syncToggleError:   'No se pudo cambiar el sync. Intentá de nuevo.',

    // Preview del payload
    payloadTitle:      'Último sync enviado',
    payloadEmpty:      'Todavía no sincronizaste ningún análisis.',
    payloadShowBtn:    'Ver datos enviados',
    payloadHideBtn:    'Ocultar datos',
    payloadDescription:'Esto es exactamente lo que recibe el coach cuando hacés sync.',

    // Salir del team
    leaveBtn:          'Salir del team',
    leaveModalTitle:   '¿Salir del team?',
    leaveModalBody:    'Al salir, el coach ya no va a poder ver tus stats futuras. ¿Qué hacemos con tus contribuciones históricas?',
    leaveOptionAnon:   'Mantener de forma anónima (el coach ve el promedio del team pero sin saber que son tus datos)',
    leaveOptionDelete: 'Borrar todo (tus stats dejan de estar en el team)',
    leaveConfirmBtn:   'Confirmar y salir',
    leaveCancelBtn:    'Cancelar',
    leaving:           'Saliendo...',
    leaveSuccess:      'Saliste del team.',
    leaveError:        'Error al salir del team. Intentá de nuevo.',

    // Dashboard del coach
    dashboardTitle:    'Dashboard del Team',
    seats:             '{{active}} / {{total}} asientos',
    seatsLabel:        'Asientos',
    rosterTitle:       'Roster',
    rosterEmpty:       'Todavía no hay miembros.',
    colPlayer:         'Jugador',
    colStatus:         'Estado',
    colSync:           'Sync',
    colLastSync:       'Último sync',
    colHands:          'Manos',
    noSyncData:        'Sin datos',
    syncOffNotice:     '{{count}} jugador(es) con sync desactivado. Solicitales que lo activen para verlos en el dashboard.',
    teamStatsTitle:    'Stats del Team',
    teamStatsEmpty:    'Ningún miembro tiene sync activo todavía.',
    teamStatsHands:    '{{count}} manos combinadas',

    // Invitar
    inviteTitle:           'Invitar jugadores',
    inviteEmail:           'Email del jugador',
    inviteEmailPlaceholder:'jugador@email.com',
    inviteNamePlaceholder: 'Nombre (opcional)',
    inviteNameHelp:        'El nombre te ayuda a identificar al jugador en el roster.',
    inviteSendBtn:         'Enviar invitación',
    inviteSending:         'Enviando...',
    inviteSuccess:        'Invitación enviada a {{email}}.',
    inviteSuccessNoEmail: 'Invitación creada para {{email}}, pero el email no se pudo enviar. Compartí el link de invitación manualmente.',
    inviteErrorSeats:  'El team está lleno ({{total}} asientos ocupados).',
    inviteErrorAlready:'Este jugador ya es miembro del team.',
    inviteErrorGeneral:'Error al enviar la invitación. Intentá de nuevo.',
    inviteLinkLabel:   'Link de invitación',
    inviteLinkCopy:    'Copiar link',
    inviteLinkCopied:  '¡Copiado!',

    // Remover miembro
    removeMemberBtn:       'Remover',
    removeMemberConfirm:   '¿Remover a {{email}} del team? Sus stats dejarán de contribuir al dashboard.',
    removeMemberConfirmBtn:'Confirmar',
    removeMemberError:     'Error al remover al miembro. Intentá de nuevo.',

    // Settings del team (owner)
    settingsTitle:       'Configuración del team',
    settingsName:        'Nombre del team',
    settingsSaveBtn:     'Guardar cambios',
    settingsSaving:      'Guardando...',
    settingsSaved:       '¡Guardado!',
    publicDisplayLabel:  'Aparecer en la landing de GrindLog',
    publicDisplayHelp:   'Si activás esto, el nombre de tu team puede aparecer en la sección "Teams que usan GrindLog" de la landing page.',
    publicDisplayName:   'Nombre público del team',
    publicDisplayNameHelp:'El nombre que se va a mostrar públicamente. Puede ser diferente al nombre interno.',

    // Consent screen (crítico — revisar copy con native speaker)
    consentTitle:         'Invitación a {{teamName}}',
    consentSubtitle:      'Tu coach quiere ver tus stats en el dashboard del team.',
    consentSharedTitle:   '¿Qué se comparte si activás Team Sync?',
    consentShared1:       'Stats agregados: VPIP, PFR, 3Bet, CBet por textura y posición, Fold to Push, etc.',
    consentShared2:       'Cantidad de manos analizadas y rango de fechas.',
    consentShared3:       'Rango de stakes de los torneos importados.',
    consentNotSharedTitle:'¿Qué NUNCA se comparte?',
    consentNotShared1:    'Tus hand histories crudas. Solo salen de tu dispositivo para el análisis local.',
    consentNotShared2:    'Acciones individuales, oponentes, cartas o timestamps exactos por mano.',
    consentNotShared3:    'Tu email o cualquier información de identificación a terceros.',
    consentWhen:          '¿Cuándo se envían?',
    consentWhenBody:      'Solo cuando importás un análisis y tenés Team Sync activo. Nunca en background.',
    consentWho:           '¿Quién puede verlo?',
    consentWhoBody:       'Solo el coach del team, {{coachEmail}}.',
    consentControl:       '¿Podés cambiar de opinión?',
    consentControlBody:   'Sí. Podés desactivar Team Sync o salir del team en cualquier momento desde la sección "Mi Team".',
    consentAcceptSync:    'Aceptar e ingresar con Sync activo',
    consentAcceptNoSync:  'Ingresar sin compartir datos (Sync desactivado)',
    consentAccepting:     'Ingresando...',
    consentExpired:       'Esta invitación expiró. Pedile al coach que te envíe una nueva.',
    consentInvalid:       'Invitación inválida.',
    consentAlreadyMember: 'Ya sos miembro de este team.',
    consentAcceptError:   'Error al unirte al team.',
    consentSupportHint:   'Si el problema persiste, contactá a soporte:',

    // Notificación de sync post-import
    syncNotice:    'Stats sincronizados con tu team.',
    syncRateLimit: 'Sync omitido (esperá 60 segundos entre syncs).',

    // Pricing por tiers
    pricingTitle:        'GrindLog for Teams',
    pricingSubtitle:     'Pro para todo el equipo. Dashboard del coach. Privacidad primero.',
    pricingMonthly:      'Mensual',
    pricingAnnual:       'Anual · ahorrá 20%',
    pricingPerMonth:     'mes',
    pricingPerYear:      'año',
    pricingCheckoutBtn:  'Suscribirse ·',
    pricingContact:      '¿Más de 20 jugadores? Escribinos:',
    pricingFeature1:     'Pro para cada jugador del team',
    pricingFeature2:     'Dashboard del coach con leaks del equipo',
    pricingFeature3:     'Drill-down por jugador (con consentimiento)',
    pricingFeature4:     'Hand histories nunca salen de tu dispositivo',
    pricingLaunchBadge:  'Primeros 10 teams: precio fijo por 2 años',

    // Seats breakdown
    seatsPlanActive:     'Tenés {{seats}} seats activados. Ya podés crear tu team.',
    seatsActiveInvited:  '{{active}} activos · {{invited}} invitados',
    seatsAtCapacity:     'Todos los seats están ocupados. Para ampliar tu plan contactá:',
    seatsOverAllocated:  'Tu team tiene {{actual}} seats ocupados pero contrataste {{contracted}}. No podés invitar más hasta regularizar. Contactá:',

    // Consent screen — estado seats llenos
    consentSeatsFull: 'Este team está lleno. No hay seats disponibles. Contactá al coach para que amplíe su plan.',

    // Invites pendientes
    pendingInvitesTitle:  'Invitaciones pendientes',
    inviteExpires:        'Vence',
    inviteRevoke:         'Cancelar',

    // Transferir ownership
    transferOwnershipTitle:      'Transferir ownership',
    transferOwnershipDesc:       'Pasá el control del team a otro miembro activo. Esta acción no se puede deshacer: vos pasás a ser jugador.',
    transferOwnershipSelect:     'Elegir nuevo coach...',
    transferOwnershipConfirm:    '¿Transferir control a {{email}}?',
    transferOwnershipConfirmBtn: 'Confirmar transferencia',

    // A1: Vista completa por jugador (CoachPlayerView)
    viewPlayerStats:        'Ver stats',
    playerStatsSubtitle:    'Stats del jugador',
    playerStatsHands:       'manos',
    playerStatsClose:       'Cerrar',
    playerStatsNoData:      'Este jugador todavía no sincronizó ningún análisis.',
    playerStatsLeakCritical:'leak(s) crítico(s)',
    playerStatsLeakWarn:    'aviso(s)',

    // A2: Tabla comparativa del team (TeamComparisonTable)
    comparisonTitle:  'Comparativa del team',
    comparisonNoData: 'Ningún miembro sincronizó estadísticas todavía.',
    colCbet:          'CBet',
    colFoldTo3bet:    'Fold/3B',
    colFoldToPush:    'Fold/Push',
    legendOk:         'dentro del rango',
    legendWarn:       'fuera del rango',
    legendCritical:   'leak crítico',

    // Tabs del modal de coaching
    statsTabPreflop:  'Preflop',
    statsTabPostflop: 'Postflop',

    // A3: Panel de leaks del team (TeamLeaksPanel)
    leaksTitle:            'Leaks del team',
    leaksNoData:           'Ningún miembro sincronizó estadísticas todavía.',
    leaksSummaryPlayers:   'jugador(es) con leaks críticos',
    leaksSummaryWarnOnly:  'solo warnings',
    leaksAllGood:          'Ningún leak crítico detectado',
    leaksFilterCritical:   '● Críticos',
    leaksFilterAll:        'Todos',
    leaksBadgeCritical:    'crítico(s)',
    leaksBadgeWarn:        'warning(s)',
    leaksPlayerClean:      'Sin leaks detectados',
    leaksLowSample:        'muestra baja',
    leaksRange:            'rango',

    // Editor de benchmarks
    benchmarks: {
      sectionTitle:    'Benchmarks del Team',
      title:           'RANGOS PERSONALIZADOS',
      subtitle:        'Configurá rangos objetivo para tus jugadores. Dejá un campo vacío para usar el default global.',
      loading:         'Cargando benchmarks...',
      colStat:         'Stat',
      colPosition:     'Posición',
      colDefault:      'Default',
      colOverrideMin:  'Mín',
      colOverrideMax:  'Máx',
      allFallbackHint: '(ALL aplica a todos los stacks salvo que se sobreescriba)',
      saveBtn:         'Guardar benchmarks',
      saving:          'Guardando...',
      savedOk:         '✓ Guardado',
      savedErr:        'Error al guardar. Intentá de nuevo.',
      resetCategory:   'Resetear categoría',
      footerHint:      'Los jugadores del team verán estos rangos en su panel de stats.',
    },
  },
};

export type Translations = typeof es;
